import jQuery from 'jquery';

class Form {

    constructor() {
      this.parents = document.querySelectorAll('.js-sub-field')
      this.groupedRadios = document.querySelectorAll('.js-grouped-radios input[type="checkbox"]')
	  this.noDisabled = document.querySelectorAll('.js-no-disabled')
	  this.formFooter = document.querySelector('.gform_footer')

	  this.multiSelect = document.querySelector('.ginput_container_multiselect')

	  this.counter = 0

	  this.resumeInput = document.querySelector('#gform_resume_email')

	  this.currencies = document.querySelectorAll('.input-currency input')
    }
  
    init() {		
		this.events()
    }
	
    events() {
		const self = this;

		if ( self.parents ) {
			self.parents.forEach( ( parent, p ) => {
				parent.querySelectorAll('.gchoice').forEach( ( item, i ) => {
					setTimeout( () => {
						item.querySelector('input').disabled = false
						self.moveChildItem( item, i, p )
					}, 2000)
				})
			})
		}

		if ( self.noDisabled ) {
			self.noDisabled.forEach( ( item ) => {
				setTimeout( () => {
					if ( item.querySelector('select') ) {
						item.querySelector('select').removeAttribute("disabled")
					}
					if ( item.querySelector('input') ) {
						item.querySelector('input').removeAttribute("disabled")
					}
				}, 2000)
			})
		}

		if ( self.groupedRadios ) {
			self.groupedRadios.forEach( ( radio, r ) => {
				setTimeout( () => {
					self.isAllChecked( r )
				}, 300)

				radio.addEventListener('change', () => {
					self.isAllChecked( r )
				})
			})

		}

		if ( self.resumeInput ) {
			self.resumeInput.placeholder = 'Email address*'
		}

		if ( self.multiSelect ) {
			setTimeout( () => {
				self.multiSelect.addEventListener('DOMSubtreeModified', () => {
					self.handleSelected( self.multiSelect.querySelectorAll('.search-choice-close') )
				})
			}, 100)
		}
		
		if ( self.currencies ) {
			self.currencies.forEach( currency => {
				currency.addEventListener( 'input', () => {					
					currency.value = currency.value.replace( /,/g, '' )

					var regExp = /^\d*$/;
					// var regExp = /^[1-9]\d*(\.\d+)?$/;
					if ( ! regExp.test( currency.value ) ) {

						if ( currency.value.length < 2 ) {
							currency.value = '';
						} else {
							currency.value = currency.value.slice(0, -1);
						}
					}
					
					currency.value = new Intl.NumberFormat( 'en-GB', {
						minimumFractionDigits: 2,
  						maximumFractionDigits: 2,
						trailingZeroDisplay: 'stripIfInteger'
					} ).format( currency.value )
				})
			} )
		}
    }

	handleSelected( items ) {
		const searchCont = document.querySelector('.chosen-container')

		items.forEach( ( selected ) => {
			selected.addEventListener('click', () => {
				searchCont.classList.remove('chosen-with-drop')
				searchCont.classList.remove('chosen-container-active')
			})
		})
	}

	moveChildItem( item, i, p ) {
		document.querySelectorAll('.js-parent-' + p + '.js-move-' + i).forEach( ( field ) => {
			const fragment = document.createDocumentFragment()
			field.querySelector('input').disabled = false
			fragment.appendChild( field )
			item.appendChild( fragment )
		} )
	}

	isAllChecked( i ) {
		let max_count = 3;

		if ( window.location.hostname === 'jimjoelfund.org' ) {
			max_count = 2;
		}

		if ( this.groupedRadios[i].checked ) {
            this.counter++;
        } else {
			this.counter--;
		}

		if ( this.counter == 0 || this.counter == max_count ) {
            this.formFooter.classList.add('show')
        } else {
            this.formFooter.classList.remove('show')
		}
	}

  }
  
  export default Form
  